const routes = [
    {
        path: "/role",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'role_show',
        }
    }
];

export default routes;
